import {defineNuxtPlugin, useRoute} from '#imports';
import {useDataTracking} from '../composables/useDataTracking';

export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute();
    const {trackPageView} = useDataTracking();
    let lastTrackedPath: string | undefined;

    nuxtApp.hook('page:loading:end', () => {
        if (route.path === lastTrackedPath) {
            return;
        }

        lastTrackedPath = route.path;

        if (route.meta.trackPageView === false) {
            return;
        }
        trackPageView();
    });
});
